var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 68,
    viewBox: "0 0 77 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000006187"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624676",
    x: 23.3118,
    y: 1,
    width: 22.0799,
    height: 21.3502,
    rx: 2.64847,
    stroke: "#7646D7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624677",
    x: 29.1493,
    y: 1,
    width: 10.4048,
    height: 3.83755,
    rx: 1.91878,
    stroke: "#7646D7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624676_2",
    x: 13.0961,
    y: 22.8909,
    width: 22.0799,
    height: 21.3502,
    rx: 2.64847,
    stroke: "#7646D7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624677_2",
    x: 18.9336,
    y: 22.8909,
    width: 10.4048,
    height: 3.83755,
    rx: 1.91878,
    stroke: "#7646D7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624676_3",
    x: 1.4209,
    y: 44.7817,
    width: 22.0799,
    height: 21.3502,
    rx: 2.64847,
    stroke: "#7646D7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624677_3",
    x: 7.25842,
    y: 44.7817,
    width: 10.4048,
    height: 3.83755,
    rx: 1.91878,
    stroke: "#7646D7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624678",
    x: 7.17058,
    y: 61.4767,
    width: 5.47271,
    height: 0.364847,
    rx: 0.182424,
    stroke: "#7646D7",
    strokeWidth: 0.364847
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624679",
    x: 29.0615,
    y: 61.4767,
    width: 5.47271,
    height: 0.364847,
    rx: 0.182424,
    stroke: "#7646D7",
    strokeWidth: 0.364847
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624682",
    x: 49.4928,
    y: 61.4767,
    width: 5.47271,
    height: 0.364847,
    rx: 0.182424,
    stroke: "#7646D7",
    strokeWidth: 0.364847
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624680",
    x: 18.116,
    y: 39.586,
    width: 5.47271,
    height: 0.364847,
    rx: 0.182424,
    stroke: "#7646D7",
    strokeWidth: 0.364847
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624681",
    x: 28.3317,
    y: 17.6951,
    width: 5.47271,
    height: 0.364847,
    rx: 0.182424,
    stroke: "#7646D7",
    strokeWidth: 0.364847
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624676_4",
    x: 23.3118,
    y: 44.7817,
    width: 22.0799,
    height: 21.3502,
    rx: 2.64847,
    stroke: "#7646D7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624677_4",
    x: 29.1493,
    y: 44.7817,
    width: 10.4048,
    height: 3.83755,
    rx: 1.91878,
    stroke: "#7646D7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624676_5",
    x: 43.7432,
    y: 44.7817,
    width: 22.0799,
    height: 21.3502,
    rx: 2.64847,
    stroke: "#7646D7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 501",
    d: "M54.7831 53.2677L33.9868 26.9987L41.6486 17.1478H68.2824L75.5794 26.9987L54.7831 53.2677Z",
    fill: "white",
    stroke: "#7646D7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector 502"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.7832 48.8896L46.3917 26.269L54.7832 17.5127H67.188L63.1747 26.269L54.7832 48.8896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6487 18.2424L46.3917 26.269M46.3917 26.269L54.7832 48.8896L63.1747 26.269M46.3917 26.269L54.7832 17.5127M63.1747 26.269L67.188 17.5127H54.7832M63.1747 26.269L54.7832 17.5127M35.0814 26.269H75.2146",
    stroke: "#7646D7",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.abd4f8ad24562479537dce85e1c9497e.svg";
export { ForwardRef as ReactComponent };